var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.question.label)?_c('h3',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.question.label))]):_vm._e(),_vm._v(" "),_c('RichContent',{staticClass:"reset-liststyle",attrs:{"content":_vm.value.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }